// extracted by mini-css-extract-plugin
export default {"headingContainer":"heading_headingContainer__e3lvr","title":"heading_title__fi14a"};